var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTshirt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11_163)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.5212 1.31641H26.3284V2.57014C26.3284 5.50821 23.9381 7.8985 21 7.8985C18.0619 7.8985 15.6716 5.50821 15.6716 2.57014V1.31641H7.47876L0 5.95329V18.3045H6.58209V40.6836H35.4179V18.3045H42V5.95329L34.5212 1.31641ZM39.4925 15.797H32.9104V38.1761H9.08955V15.797H2.50746V7.34886L8.19288 3.82387H13.2643C13.8663 7.55063 17.1059 10.406 20.9999 10.406C24.8939 10.406 28.1336 7.55063 28.7355 3.82387H33.807L39.4925 7.34886V15.797Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9856 18.8329H15.1642V30.4447H17.6716V16.3254H13.9856V18.8329Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7236 16.0933C22.2178 16.0933 20.1792 18.1319 20.1792 20.6377V25.9003C20.1792 28.4061 22.2178 30.4447 24.7236 30.4447C27.2293 30.4447 29.268 28.4061 29.268 25.9003V20.6377C29.268 18.1319 27.2293 16.0933 24.7236 16.0933ZM26.7605 25.9003C26.7605 27.0235 25.8467 27.9373 24.7236 27.9373C23.6004 27.9373 22.6867 27.0235 22.6867 25.9003V20.6377C22.6867 19.5145 23.6005 18.6007 24.7236 18.6007C25.8467 18.6007 26.7605 19.5145 26.7605 20.6377V25.9003Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11_163"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTshirt);
export default __webpack_public_path__ + "static/media/tshirt.5ad809600d848007ce1a9a91cc1d458a.svg";
export { ForwardRef as ReactComponent };